import React from "react";

const RestaurantSchema = () => (
    <React.Fragment>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(
                    {
                        "@context": "http://schema.org",
                        "@type": "Restaurant",
                        "servesCuisine": [
                            "Italian",
                            "Indian",
                            "Chinese"
                        ],
                        "logo": "https://www.hoteltwintowers.com/icons/header-logo.svg",
                        "image": "https://www.hoteltwintowers.com/images/restaurant-banner.png",
                        "priceRange": "",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "NH 05, New kufri, Galu, Hills,",
                            "addressLocality": "Shimla",
                            "addressRegion": "Indian Himalayan Region",
                            "postalCode": "171209",
                            "addressCountry": "India"
                        },

                        "name": "The Twin Towers Hotel",
                        "telephone": "+91 07807885113",
                        "email": "info@hoteltwintowers.com",
                        "url": "https://www.hoteltwintowers.com/bar-and-restaurant",
                        "hasMenu": "",
                        "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                        "containedInPlace": {
                            "@type": "Place",
                            "name": "The Twin Towers Hotel",
                            "url": "https://www.hoteltwintowers.com",
                            "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5"
                        }
                    }
                )
            }}
        />
    </React.Fragment>
);

export default RestaurantSchema;